import { LANGUAGE } from "@/common/utils/constants.js";
import { CATEGORY_TRANSLATIONS } from '@/drc/translations/category/categoryTranslations';
import { PROJECT_TRANSLATIONS } from '@/drc/translations/project/projectTranslations';
import { SEARCH_PAGE_TRANSLATIONS } from '@/drc/translations/search/searchPageTranslations';
import { LABEL_TRANSLATIONS } from '@/drc/translations/labels/labelTranslations';

import Vue from "vue";
import VueI18n from "vue-i18n";
import { NOTIFICATION_TRANSLATIONS } from '@/common/translations/notifications/notificationTranslations';

import { FAQ_PAGE } from "@/drc/translations/faq/faq-page";
import { HOME_PAGE } from "@/drc/translations/home/home-page";
import { SIDE_MENU } from "@/common/translations/sideMenu/sidemenu";
import { PROJECT_FORMS_TRANSLATIONS } from "@/drc/translations/components/projectForms";
import { STEPS_FORM_SECTION_TRANSLATIONS } from "@/drc/translations/components/projectFromSections";
import { STEPS_FORM_GUIDES_TRANSLATIONS } from "@/drc/translations/components/submissionFromGuides";
import { PROJECT_FORMS_VALIDATIONS_TRANSLATIONS } from "@/drc/translations/components/projectFormsValidations";
import { FORMS_NOTIFICATIONS } from "@/drc/translations/notifications/form-notifications";
import { GLOBAL_SEARCH_SECTIONS } from "@/drc/translations/components/globalSearchSections";
import { MANAGEMENT_STATUSES } from "@/drc/translations/management/management-statuses";
import { MANAGEMENT_PAGE } from "@/drc/translations/management/management-page";
import { LOGIN_PAGE } from "@/common/translations/loginPage/login-page";
import { VALIDATE_IN } from "@/drc/translations/components/validatein";
import { SAVED_PROJECTS } from "@/drc/translations/components/saved-projects";
import { MY_PROJECTS_PAGE } from "@/drc/translations/myProjects/my-projects-page";
import { BUTTONS } from "@/drc/translations/components/buttons";

import { COMMON_PPT } from "@/drc/services/ppt/utils/pptCommonTranslations";
import { ABOUT_THE_CLIENT_PPT } from "@/drc/services/ppt/slidesSections/aboutTheClient/aboutTheClientTranslations";
import { HOME_PPT } from "@/drc/services/ppt/slidesSections/home/homeTranslations";
import { CLIENT_CONTEXT_PPT } from "@/drc/services/ppt/slidesSections/clientContextAndSolutions/clientContextAndSolutionsTranslations";
import { ADDITIONAL_INFORMATION_PPT } from "@/drc/services/ppt/slidesSections/additionalInformation/additionalInformationTranslations";
import { PICTURES_PPT } from "@/drc/services/ppt/slidesSections/pictures/picturesTranslations";
import { CLIENT_RESULT_PPT } from "@/drc/services/ppt/slidesSections/clientResult/clientResultTranslations";
import { END_SLIDE_PPT } from "@/drc/services/ppt/slidesSections/end/endSlideTranslations";

import { COMMON_DOCX } from "@/drc/services/docx/utils/pptdocxCommonTranslations"
import { HOME_DOCX } from "@/drc/services/docx/sections/home/homeTranslations"
import { ABOUT_THE_CLIENT_DOCX } from "@/drc/services/docx/sections/aboutTheClient/aboutTheClientTranslations"
import { CLIENT_CONTEXT_DOCX } from "@/drc/services/docx/sections/clientContext/clientContextTranslations"
import { AKKODIS_SOLUTION_DOCX } from "@/drc/services/docx/sections/akkodisSolution/akkodisSolutionTranslations"
import { CLIENT_RESULT_DOCX } from "@/drc/services/docx/sections/clientResult/clientResultTranslations"
import { ADDITIONAL_INFORMATION_DOCX } from "@/drc/services/docx/sections/additionalInformation/additionalInformationTranslations"
import { CRUD_SIDE_MENU } from "@/drc/translations/components/crudSideMenu";
import { COMMON } from "@/common/translations/common"
import { MANAGEMENT_LABELS } from "@/drc/translations/management/management-labels"
import { CONTROL_PANEL_TRANSLATIONS } from "@/drc/translations/controlPanel/controlPanelTranslations"
import { LANDING_PAGE } from "@/common/translations/landingPage/landing-page"
import {ERROR_PAGE} from "@/common/translations/errorPage/errorPage"
import {GOP_HOME_PAGE} from "@/gop/translations/gopHomePage"
import {GOP_ITEM_PAGE} from "@/gop/translations/gopItemPage"
import {GOP_OFFERS} from "@/gop/translations/gopOffers";
import { COMMON_PDF } from "@/drc/services/pdf/pdfCommonTranslations"

import {DRC_SUBMISSION_FORM_TRANSLATIONS} from "@/drc/translations/submissionForm/submissionForm"
import {DRC_SUBSCRIPTIONS} from "@/drc/translations/subscriptions/subscriptions"
import {GOP_HOME_PAGE_TRANSLATIONS} from '@/gop-redesign/translations/gopHomePageTranslations'
import {GOP_SEARCH_TRANSLATIONS} from "@/gop-redesign/translations/gopSearchTranslations";
import {GOP_FOOTER} from "@/gop-redesign/translations/gopFooter";
import {GOP_VIEW_PAGE} from "@/gop-redesign/translations/gopViewPage";
import {GOP_COMPONENTS} from "@/gop-redesign/translations/gopComponents";

Vue.use(VueI18n);

const translations = {
	[LANGUAGE.en.short]: {
		formsNotifications: {
			...FORMS_NOTIFICATIONS[LANGUAGE.en.short]
		},
		projectFroms: {
			...PROJECT_FORMS_TRANSLATIONS[LANGUAGE.en.short]
		},
		projectFormValidations: {
			...PROJECT_FORMS_VALIDATIONS_TRANSLATIONS[LANGUAGE.en.short]
		},
		projectSubmissionNavigation: {
			...STEPS_FORM_SECTION_TRANSLATIONS[LANGUAGE.en.short]
		},
		projectSubmisionGoudes: {
			...STEPS_FORM_GUIDES_TRANSLATIONS[LANGUAGE.en.short]
		},
		faqPage: {
			...FAQ_PAGE[LANGUAGE.en.short]
		},
		homePage: {
			...HOME_PAGE[LANGUAGE.en.short]
		},
		sideMenu: {
			...SIDE_MENU[LANGUAGE.en.short]
		},
		globalSearchSections: {
			...GLOBAL_SEARCH_SECTIONS[LANGUAGE.en.short]
		},
		category: {
			...CATEGORY_TRANSLATIONS[LANGUAGE.en.short]
		},
		projectPage: {
			...PROJECT_TRANSLATIONS[LANGUAGE.en.short]
		},
		searchPage: {
			...SEARCH_PAGE_TRANSLATIONS[LANGUAGE.en.short]
		},
		labels: {
			...LABEL_TRANSLATIONS[LANGUAGE.en.short]
		},
		notifications: {
			...NOTIFICATION_TRANSLATIONS[LANGUAGE.en.short]
		},
		managementPage: {
			...MANAGEMENT_STATUSES[LANGUAGE.en.short],
			...MANAGEMENT_PAGE[LANGUAGE.en.short]
		},
		content: {
			...LOGIN_PAGE[LANGUAGE.en.short],
		},
		...MY_PROJECTS_PAGE[LANGUAGE.en.short],
		...SAVED_PROJECTS[LANGUAGE.en.short],
		search: {
			...VALIDATE_IN[LANGUAGE.en.short],
		},
		buttons: {
			...BUTTONS[LANGUAGE.en.short]
		},
		aboutTheClientPPT: {
			...ABOUT_THE_CLIENT_PPT[LANGUAGE.en.short]
		},
		homePPT: {
			...HOME_PPT[LANGUAGE.en.short]
		},
		clientContextPPT: {
			...CLIENT_CONTEXT_PPT[LANGUAGE.en.short]
		},
		endPPT: {
			...END_SLIDE_PPT[LANGUAGE.en.short]
		},
		additionalInformationPPT: {
			...ADDITIONAL_INFORMATION_PPT[LANGUAGE.en.short]
		},
		commonPPT: {
			...COMMON_PPT[LANGUAGE.en.short]
		},
		picturePPT: {
			...PICTURES_PPT[LANGUAGE.en.short]
		},
		clientResultPPT: {
			...CLIENT_RESULT_PPT[LANGUAGE.en.short]
		},
		commonDOCX: {
			...COMMON_DOCX[LANGUAGE.en.short]
		},
		homeDOCX: {
			...HOME_DOCX[LANGUAGE.en.short]
		},
		aboutTheClientDOCX: {
			...ABOUT_THE_CLIENT_DOCX[LANGUAGE.en.short]
		},
		clientContextDOCX: {
			...CLIENT_CONTEXT_DOCX[LANGUAGE.en.short]
		},
		akkoidsSolutionDOCX: {
			...AKKODIS_SOLUTION_DOCX[LANGUAGE.en.short]
		},
		clientResultDOCX: {
			...CLIENT_RESULT_DOCX[LANGUAGE.en.short]
		},
		additionalInformationDOCX: {
			...ADDITIONAL_INFORMATION_DOCX[LANGUAGE.en.short]
		},
		crudSideMenu: {
			...CRUD_SIDE_MENU[LANGUAGE.en.short]
		},
		common: {
			...COMMON[LANGUAGE.en.short]
		},
		managementLabels: {
			...MANAGEMENT_LABELS[LANGUAGE.en.short]
		},
		controlPanel: {
			...CONTROL_PANEL_TRANSLATIONS[LANGUAGE.en.short]
		},
		landingPage: {
			...LANDING_PAGE[LANGUAGE.en.short]
		},
		errorPage: {
			...ERROR_PAGE[LANGUAGE.en.short]
		},
		gopHomePage: {
			...GOP_HOME_PAGE[LANGUAGE.en.short]
		},
		gopItemPage: {
			...GOP_ITEM_PAGE[LANGUAGE.en.short]
		},
		gopOffers: {
			...GOP_OFFERS[LANGUAGE.en.short]
		},
		commonPdf: {
			...COMMON_PDF[LANGUAGE.en.short]
		},
		submissionForm: {
			...DRC_SUBMISSION_FORM_TRANSLATIONS[LANGUAGE.en.short]
		},
		subscriptions: {
			...DRC_SUBSCRIPTIONS[LANGUAGE.en.short]
		},
		gopHomePageTranslations: {
			...GOP_HOME_PAGE_TRANSLATIONS[LANGUAGE.en.short]
		},
		gopSearchTranslations: {
			...GOP_SEARCH_TRANSLATIONS[LANGUAGE.en.short]
		},
		gopFooter: {
			...GOP_FOOTER[LANGUAGE.en.short]
		},
		gopComponents: {
			...GOP_COMPONENTS[LANGUAGE.en.short]
		},
		gopViewPage: {
			...GOP_VIEW_PAGE[LANGUAGE.en.short]
		}
	},
	[LANGUAGE.de.short]: {
		formsNotifications: {
			...FORMS_NOTIFICATIONS[LANGUAGE.de.short]
		},
		category: {
			...CATEGORY_TRANSLATIONS[LANGUAGE.de.short]
		},
		projectFroms: {
			...PROJECT_FORMS_TRANSLATIONS[LANGUAGE.de.short]
		},
		projectFormValidations: {
			...PROJECT_FORMS_VALIDATIONS_TRANSLATIONS[LANGUAGE.de.short]
		},
		projectSubmissionNavigation: {
			...STEPS_FORM_SECTION_TRANSLATIONS[LANGUAGE.de.short]
		},
		projectSubmisionGoudes: {
			...STEPS_FORM_GUIDES_TRANSLATIONS[LANGUAGE.de.short]
		},
		faqPage: {
			...FAQ_PAGE[LANGUAGE.de.short]
		},
		sideMenu: {
			...SIDE_MENU[LANGUAGE.de.short]
		},
		globalSearchSections: {
			...GLOBAL_SEARCH_SECTIONS[LANGUAGE.de.short]
		},
		homePage: {
			...HOME_PAGE[LANGUAGE.de.short]
		},
		projectPage: {
			...PROJECT_TRANSLATIONS[LANGUAGE.de.short]
		},
		searchPage: {
			...SEARCH_PAGE_TRANSLATIONS[LANGUAGE.de.short]
		},
		labels: {
			...LABEL_TRANSLATIONS[LANGUAGE.de.short]
		},
		notifications: {
			...NOTIFICATION_TRANSLATIONS[LANGUAGE.de.short]
		},
		managementPage: {
			...MANAGEMENT_STATUSES[LANGUAGE.de.short],
			...MANAGEMENT_PAGE[LANGUAGE.de.short]
		},
		content: {
			...LOGIN_PAGE[LANGUAGE.de.short],
		},
		buttons: {
			...BUTTONS[LANGUAGE.de.short]
		},
		validatedProjectMessage: "Der Inhalt wurde am {date} von {validator} validiert.",
		revalidate: 'Erneut validieren',
		notValidatedProjectMessage: "Dieses Projekt wird automatisch übersetzt. Bitte prüfen und gegebenenfalls bearbeiten.",
		...MY_PROJECTS_PAGE[LANGUAGE.de.short],
		...SAVED_PROJECTS[LANGUAGE.de.short],
		search: {
			...VALIDATE_IN[LANGUAGE.de.short],
		},
		aboutTheClientPPT: {
			...ABOUT_THE_CLIENT_PPT[LANGUAGE.de.short]
		},
		homePPT: {
			...HOME_PPT[LANGUAGE.de.short]
		},
		clientContextPPT: {
			...CLIENT_CONTEXT_PPT[LANGUAGE.de.short]
		},
		endPPT: {
			...END_SLIDE_PPT[LANGUAGE.de.short]
		},
		additionalInformationPPT: {
			...ADDITIONAL_INFORMATION_PPT[LANGUAGE.de.short]
		},
		commonPPT: {
			...COMMON_PPT[LANGUAGE.de.short]
		},
		picturePPT: {
			...PICTURES_PPT[LANGUAGE.de.short]
		},
		clientResultPPT: {
			...CLIENT_RESULT_PPT[LANGUAGE.de.short]
		},
		commonDOCX: {
			...COMMON_DOCX[LANGUAGE.de.short]
		},
		homeDOCX: {
			...HOME_DOCX[LANGUAGE.de.short]
		},
		aboutTheClientDOCX: {
			...ABOUT_THE_CLIENT_DOCX[LANGUAGE.de.short]
		},
		clientContextDOCX: {
			...CLIENT_CONTEXT_DOCX[LANGUAGE.de.short]
		},
		akkoidsSolutionDOCX: {
			...AKKODIS_SOLUTION_DOCX[LANGUAGE.de.short]
		},
		clientResultDOCX: {
			...CLIENT_RESULT_DOCX[LANGUAGE.de.short]
		},
		additionalInformationDOCX: {
			...ADDITIONAL_INFORMATION_DOCX[LANGUAGE.de.short]
		},
		crudSideMenu: {
			...CRUD_SIDE_MENU[LANGUAGE.de.short]
		},
		common: {
			...COMMON[LANGUAGE.de.short]
		},
		managementLabels: {
			...MANAGEMENT_LABELS[LANGUAGE.de.short]
		},
		controlPanel: {
			...CONTROL_PANEL_TRANSLATIONS[LANGUAGE.de.short]
		},
		landingPage: {
			...LANDING_PAGE[LANGUAGE.de.short]
		},
		errorPage: {
			...ERROR_PAGE[LANGUAGE.de.short]
		},
		gopHomePage: {
			...GOP_HOME_PAGE[LANGUAGE.de.short]
		},
		gopItemPage: {
			...GOP_ITEM_PAGE[LANGUAGE.de.short]
		},
		gopOffers: {
			...GOP_OFFERS[LANGUAGE.de.short]
		},
		commonPdf: {
			...COMMON_PDF[LANGUAGE.de.short]
		},
		submissionForm: {
			...DRC_SUBMISSION_FORM_TRANSLATIONS[LANGUAGE.de.short]
		},
		subscriptions: {
			...DRC_SUBSCRIPTIONS[LANGUAGE.de.short]
		},
		gopHomePageTranslations: {
			...GOP_HOME_PAGE_TRANSLATIONS[LANGUAGE.de.short]
		},
		gopSearchTranslations: {
			...GOP_SEARCH_TRANSLATIONS[LANGUAGE.de.short]
		},
		gopFooter: {
			...GOP_FOOTER[LANGUAGE.de.short]
		},
		gopComponents: {
			...GOP_COMPONENTS[LANGUAGE.de.short]
		},
		gopViewPage: {
			...GOP_VIEW_PAGE[LANGUAGE.de.short]
		}
	},
	[LANGUAGE.fr.short]: {
		formsNotifications: {
			...FORMS_NOTIFICATIONS[LANGUAGE.fr.short]
		},
		category: {
			...CATEGORY_TRANSLATIONS[LANGUAGE.fr.short]
		},
		projectFormValidations: {
			...PROJECT_FORMS_VALIDATIONS_TRANSLATIONS[LANGUAGE.fr.short]
		},
		projectSubmissionNavigation: {
			...STEPS_FORM_SECTION_TRANSLATIONS[LANGUAGE.fr.short]
		},
		projectSubmisionGoudes: {
			...STEPS_FORM_GUIDES_TRANSLATIONS[LANGUAGE.fr.short]
		},
		projectFroms: {
			...PROJECT_FORMS_TRANSLATIONS[LANGUAGE.fr.short]
		},
		faqPage: {
			...FAQ_PAGE[LANGUAGE.fr.short]
		},
		sideMenu: {
			...SIDE_MENU[LANGUAGE.fr.short]
		},
		globalSearchSections: {
			...GLOBAL_SEARCH_SECTIONS[LANGUAGE.fr.short]
		},
		projectPage: {
			...PROJECT_TRANSLATIONS[LANGUAGE.fr.short]
		},
		homePage: {
			...HOME_PAGE[LANGUAGE.fr.short]
		},
		searchPage: {
			...SEARCH_PAGE_TRANSLATIONS[LANGUAGE.fr.short]
		},
		labels: {
			...LABEL_TRANSLATIONS[LANGUAGE.fr.short]
		},
		notifications: {
			...NOTIFICATION_TRANSLATIONS[LANGUAGE.fr.short]
		},
		managementPage: {
			...MANAGEMENT_STATUSES[LANGUAGE.fr.short],
			...MANAGEMENT_PAGE[LANGUAGE.fr.short]
		},
		content: {
			...LOGIN_PAGE[LANGUAGE.fr.short],
		},
		buttons: {
			...BUTTONS[LANGUAGE.fr.short]
		},
		validatedProjectMessage: "Le contenu a été validé par {validator} le {date}.",
		revalidate: 'Revalider',
		notValidatedProjectMessage: "Ce projet est traduit automatiquement. Veuillez réviser et modifier si nécessaire.",
		...MY_PROJECTS_PAGE[LANGUAGE.fr.short],
		...SAVED_PROJECTS[LANGUAGE.fr.short],
		search: {
			...VALIDATE_IN[LANGUAGE.fr.short],
		},
		aboutTheClientPPT: {
			...ABOUT_THE_CLIENT_PPT[LANGUAGE.fr.short]
		},
		homePPT: {
			...HOME_PPT[LANGUAGE.fr.short]
		},
		clientContextPPT: {
			...CLIENT_CONTEXT_PPT[LANGUAGE.fr.short]
		},
		endPPT: {
			...END_SLIDE_PPT[LANGUAGE.fr.short]
		},
		additionalInformationPPT: {
			...ADDITIONAL_INFORMATION_PPT[LANGUAGE.fr.short]
		},
		commonPPT: {
			...COMMON_PPT[LANGUAGE.fr.short]
		},
		picturePPT: {
			...PICTURES_PPT[LANGUAGE.fr.short]
		},
		clientResultPPT: {
			...CLIENT_RESULT_PPT[LANGUAGE.fr.short]
		},
		commonDOCX: {
			...COMMON_DOCX[LANGUAGE.fr.short]
		},
		homeDOCX: {
			...HOME_DOCX[LANGUAGE.fr.short]
		},
		aboutTheClientDOCX: {
			...ABOUT_THE_CLIENT_DOCX[LANGUAGE.fr.short]
		},
		clientContextDOCX: {
			...CLIENT_CONTEXT_DOCX[LANGUAGE.fr.short]
		},
		akkoidsSolutionDOCX: {
			...AKKODIS_SOLUTION_DOCX[LANGUAGE.fr.short]
		},
		clientResultDOCX: {
			...CLIENT_RESULT_DOCX[LANGUAGE.fr.short]
		},
		additionalInformationDOCX: {
			...ADDITIONAL_INFORMATION_DOCX[LANGUAGE.fr.short]
		},
		crudSideMenu: {
			...CRUD_SIDE_MENU[LANGUAGE.fr.short]
		},
		common: {
			...COMMON[LANGUAGE.fr.short]
		},
		managementLabels: {
			...MANAGEMENT_LABELS[LANGUAGE.fr.short]
		},
		controlPanel: {
			...CONTROL_PANEL_TRANSLATIONS[LANGUAGE.fr.short]
		},
		landingPage: {
			...LANDING_PAGE[LANGUAGE.fr.short]
		},
		errorPage: {
			...ERROR_PAGE[LANGUAGE.fr.short]
		},
		gopHomePage: {
			...GOP_HOME_PAGE[LANGUAGE.fr.short]
		},
		gopItemPage: {
			...GOP_ITEM_PAGE[LANGUAGE.fr.short]
		},
		gopOffers: {
			...GOP_OFFERS[LANGUAGE.fr.short]
		},
		commonPdf: {
			...COMMON_PDF[LANGUAGE.fr.short]
		},
		submissionForm: {
			...DRC_SUBMISSION_FORM_TRANSLATIONS[LANGUAGE.fr.short]
		},
		subscriptions: {
			...DRC_SUBSCRIPTIONS[LANGUAGE.fr.short]
		},
		gopHomePageTranslations: {
			...GOP_HOME_PAGE_TRANSLATIONS[LANGUAGE.fr.short]
		},
		gopSearchTranslations: {
			...GOP_SEARCH_TRANSLATIONS[LANGUAGE.fr.short]
		},
		gopFooter: {
			...GOP_FOOTER[LANGUAGE.fr.short]
		},
		gopComponents: {
			...GOP_COMPONENTS[LANGUAGE.fr.short]
		},
		gopViewPage: {
			...GOP_VIEW_PAGE[LANGUAGE.fr.short]
		}
	},
	[LANGUAGE.it.short]: {
		formsNotifications: {
			...FORMS_NOTIFICATIONS[LANGUAGE.it.short]
		},
		category: {
			...CATEGORY_TRANSLATIONS[LANGUAGE.it.short]
		},
		projectFroms: {
			...PROJECT_FORMS_TRANSLATIONS[LANGUAGE.it.short]
		},
		projectFormValidations: {
			...PROJECT_FORMS_VALIDATIONS_TRANSLATIONS[LANGUAGE.it.short]
		},
		projectSubmissionNavigation: {
			...STEPS_FORM_SECTION_TRANSLATIONS[LANGUAGE.it.short]
		},
		projectSubmisionGoudes: {
			...STEPS_FORM_GUIDES_TRANSLATIONS[LANGUAGE.it.short]
		},
		faqPage: {
			...FAQ_PAGE[LANGUAGE.it.short]
		},
		sideMenu: {
			...SIDE_MENU[LANGUAGE.it.short]
		},
		globalSearchSections: {
			...GLOBAL_SEARCH_SECTIONS[LANGUAGE.it.short]
		},
		projectPage: {
			...PROJECT_TRANSLATIONS[LANGUAGE.it.short]
		},
		homePage: {
			...HOME_PAGE[LANGUAGE.it.short]
		},
		searchPage: {
			...SEARCH_PAGE_TRANSLATIONS[LANGUAGE.it.short]
		},
		labels: {
			...LABEL_TRANSLATIONS[LANGUAGE.it.short]
		},
		notifications: {
			...NOTIFICATION_TRANSLATIONS[LANGUAGE.it.short]
		},
		managementPage: {
			...MANAGEMENT_STATUSES[LANGUAGE.it.short],
			...MANAGEMENT_PAGE[LANGUAGE.it.short]
		},
		content: {
			...LOGIN_PAGE[LANGUAGE.it.short],
		},
		buttons: {
			...BUTTONS[LANGUAGE.it.short]
		},
		validatedProjectMessage: "Il contenuto è stato convalidato da {validator} il {date}.",
		revalidate: 'Riconvalidare',
		notValidatedProjectMessage: "Questo progetto viene tradotto automaticamente. Si prega di rivedere e modificare se necessario.",
		...MY_PROJECTS_PAGE[LANGUAGE.it.short],
		...SAVED_PROJECTS[LANGUAGE.it.short],
		search: {
			...VALIDATE_IN[LANGUAGE.it.short],
		},
		aboutTheClientPPT: {
			...ABOUT_THE_CLIENT_PPT[LANGUAGE.it.short]
		},
		homePPT: {
			...HOME_PPT[LANGUAGE.it.short]
		},
		clientContextPPT: {
			...CLIENT_CONTEXT_PPT[LANGUAGE.it.short]
		},
		endPPT: {
			...END_SLIDE_PPT[LANGUAGE.it.short]
		},
		additionalInformationPPT: {
			...ADDITIONAL_INFORMATION_PPT[LANGUAGE.it.short]
		},
		commonPPT: {
			...COMMON_PPT[LANGUAGE.it.short]
		},
		picturePPT: {
			...PICTURES_PPT[LANGUAGE.it.short]
		},
		clientResultPPT: {
			...CLIENT_RESULT_PPT[LANGUAGE.it.short]
		},
		commonDOCX: {
			...COMMON_DOCX[LANGUAGE.it.short]
		},
		homeDOCX: {
			...HOME_DOCX[LANGUAGE.it.short]
		},
		aboutTheClientDOCX: {
			...ABOUT_THE_CLIENT_DOCX[LANGUAGE.it.short]
		},
		clientContextDOCX: {
			...CLIENT_CONTEXT_DOCX[LANGUAGE.it.short]
		},
		akkoidsSolutionDOCX: {
			...AKKODIS_SOLUTION_DOCX[LANGUAGE.it.short]
		},
		clientResultDOCX: {
			...CLIENT_RESULT_DOCX[LANGUAGE.it.short]
		},
		additionalInformationDOCX: {
			...ADDITIONAL_INFORMATION_DOCX[LANGUAGE.it.short]
		},
		crudSideMenu: {
			...CRUD_SIDE_MENU[LANGUAGE.it.short]
		},
		common: {
			...COMMON[LANGUAGE.it.short]
		},
		managementLabels: {
			...MANAGEMENT_LABELS[LANGUAGE.it.short]
		},
		controlPanel: {
			...CONTROL_PANEL_TRANSLATIONS[LANGUAGE.it.short]
		},
		landingPage: {
			...LANDING_PAGE[LANGUAGE.it.short]
		},
		errorPage: {
			...ERROR_PAGE[LANGUAGE.it.short]
		},
		gopHomePage: {
			...GOP_HOME_PAGE[LANGUAGE.it.short]
		},
		gopItemPage: {
			...GOP_ITEM_PAGE[LANGUAGE.it.short]
		},
		gopOffers: {
			...GOP_OFFERS[LANGUAGE.it.short]
		},
		commonPdf: {
			...COMMON_PDF[LANGUAGE.it.short]
		},
		submissionForm: {
			...DRC_SUBMISSION_FORM_TRANSLATIONS[LANGUAGE.it.short]
		},
		subscriptions: {
			...DRC_SUBSCRIPTIONS[LANGUAGE.it.short]
		},
		gopHomePageTranslations: {
			...GOP_HOME_PAGE_TRANSLATIONS[LANGUAGE.it.short]
		},
		gopSearchTranslations: {
			...GOP_SEARCH_TRANSLATIONS[LANGUAGE.it.short]
		},
		gopFooter: {
			...GOP_FOOTER[LANGUAGE.it.short]
		},
		gopComponents: {
			...GOP_COMPONENTS[LANGUAGE.it.short]
		},
		gopViewPage: {
			...GOP_VIEW_PAGE[LANGUAGE.it.short]
		}
	},
	[LANGUAGE.ja.short]: {
		formsNotifications: {
			...FORMS_NOTIFICATIONS[LANGUAGE.ja.short]
		},
		category: {
			...CATEGORY_TRANSLATIONS[LANGUAGE.ja.short]
		},
		projectFroms: {
			...PROJECT_FORMS_TRANSLATIONS[LANGUAGE.ja.short]
		},
		projectFormValidations: {
			...PROJECT_FORMS_VALIDATIONS_TRANSLATIONS[LANGUAGE.ja.short]
		},
		projectSubmissionNavigation: {
			...STEPS_FORM_SECTION_TRANSLATIONS[LANGUAGE.ja.short]
		},
		projectSubmisionGoudes: {
			...STEPS_FORM_GUIDES_TRANSLATIONS[LANGUAGE.ja.short]
		},
		faqPage: {
			...FAQ_PAGE[LANGUAGE.ja.short]
		},
		sideMenu: {
			...SIDE_MENU[LANGUAGE.ja.short]
		},
		globalSearchSections: {
			...GLOBAL_SEARCH_SECTIONS[LANGUAGE.ja.short]
		},
		projectPage: {
			...PROJECT_TRANSLATIONS[LANGUAGE.ja.short]
		},
		homePage: {
			...HOME_PAGE[LANGUAGE.ja.short]
		},
		searchPage: {
			...SEARCH_PAGE_TRANSLATIONS[LANGUAGE.ja.short]
		},
		labels: {
			...LABEL_TRANSLATIONS[LANGUAGE.ja.short]
		},
		notifications: {
			...NOTIFICATION_TRANSLATIONS[LANGUAGE.ja.short]
		},
		managementPage: {
			...MANAGEMENT_STATUSES[LANGUAGE.ja.short],
			...MANAGEMENT_PAGE[LANGUAGE.ja.short]
		},
		content: {
			...LOGIN_PAGE[LANGUAGE.ja.short],
		},
		buttons: {
			...BUTTONS[LANGUAGE.ja.short]
		},
		validatedProjectMessage: "この内容は、{date} 日に {validator} によって検証されました。",
		revalidate: '再検証',
		notValidatedProjectMessage: "このプロジェクトは自動翻訳されています。 必要に応じて確認および編集してください。",
		...MY_PROJECTS_PAGE[LANGUAGE.ja.short],
		...SAVED_PROJECTS[LANGUAGE.ja.short],
		search: {
			...VALIDATE_IN[LANGUAGE.ja.short],
		},
		aboutTheClientPPT: {
			...ABOUT_THE_CLIENT_PPT[LANGUAGE.ja.short]
		},
		homePPT: {
			...HOME_PPT[LANGUAGE.ja.short]
		},
		clientContextPPT: {
			...CLIENT_CONTEXT_PPT[LANGUAGE.ja.short]
		},
		endPPT: {
			...END_SLIDE_PPT[LANGUAGE.ja.short]
		},
		additionalInformationPPT: {
			...ADDITIONAL_INFORMATION_PPT[LANGUAGE.ja.short]
		},
		commonPPT: {
			...COMMON_PPT[LANGUAGE.ja.short]
		},
		picturePPT: {
			...PICTURES_PPT[LANGUAGE.ja.short]
		},
		clientResultPPT: {
			...CLIENT_RESULT_PPT[LANGUAGE.ja.short]
		},
		commonDOCX: {
			...COMMON_DOCX[LANGUAGE.ja.short]
		},
		homeDOCX: {
			...HOME_DOCX[LANGUAGE.ja.short]
		},
		aboutTheClientDOCX: {
			...ABOUT_THE_CLIENT_DOCX[LANGUAGE.ja.short]
		},
		clientContextDOCX: {
			...CLIENT_CONTEXT_DOCX[LANGUAGE.ja.short]
		},
		akkoidsSolutionDOCX: {
			...AKKODIS_SOLUTION_DOCX[LANGUAGE.ja.short]
		},
		clientResultDOCX: {
			...CLIENT_RESULT_DOCX[LANGUAGE.ja.short]
		},
		additionalInformationDOCX: {
			...ADDITIONAL_INFORMATION_DOCX[LANGUAGE.ja.short]
		},
		crudSideMenu: {
			...CRUD_SIDE_MENU[LANGUAGE.ja.short]
		},
		common: {
			...COMMON[LANGUAGE.ja.short]
		},
		managementLabels: {
			...MANAGEMENT_LABELS[LANGUAGE.ja.short]
		},
		controlPanel: {
			...CONTROL_PANEL_TRANSLATIONS[LANGUAGE.ja.short]
		},
		landingPage: {
			...LANDING_PAGE[LANGUAGE.ja.short]
		},
		errorPage: {
			...ERROR_PAGE[LANGUAGE.ja.short]
		},
		gopHomePage: {
			...GOP_HOME_PAGE[LANGUAGE.ja.short]
		},
		gopItemPage: {
			...GOP_ITEM_PAGE[LANGUAGE.ja.short]
		},
		gopOffers: {
			...GOP_OFFERS[LANGUAGE.ja.short]
		},
		commonPdf: {
			...COMMON_PDF[LANGUAGE.ja.short]
		},
		submissionForm: {
			...DRC_SUBMISSION_FORM_TRANSLATIONS[LANGUAGE.ja.short]
		},
		subscriptions: {
			...DRC_SUBSCRIPTIONS[LANGUAGE.ja.short]
		},
		gopHomePageTranslations: {
			...GOP_HOME_PAGE_TRANSLATIONS[LANGUAGE.ja.short]
		},
		gopSearchTranslations: {
			...GOP_SEARCH_TRANSLATIONS[LANGUAGE.ja.short]
		},
		gopFooter: {
			...GOP_FOOTER[LANGUAGE.ja.short]
		},
		gopComponents: {
			...GOP_COMPONENTS[LANGUAGE.ja.short]
		},
		gopViewPage: {
			...GOP_VIEW_PAGE[LANGUAGE.ja.short]
		}
	},
	[LANGUAGE.es.short]: {
		formsNotifications: {
			...FORMS_NOTIFICATIONS[LANGUAGE.es.short]
		},
		category: {
			...CATEGORY_TRANSLATIONS[LANGUAGE.es.short]
		},
		projectFroms: {
			...PROJECT_FORMS_TRANSLATIONS[LANGUAGE.es.short]
		},
		projectFormValidations: {
			...PROJECT_FORMS_VALIDATIONS_TRANSLATIONS[LANGUAGE.es.short]
		},
		projectSubmissionNavigation: {
			...STEPS_FORM_SECTION_TRANSLATIONS[LANGUAGE.es.short]
		},
		projectSubmisionGoudes: {
			...STEPS_FORM_GUIDES_TRANSLATIONS[LANGUAGE.es.short]
		},
		faqPage: {
			...FAQ_PAGE[LANGUAGE.es.short]
		},
		sideMenu: {
			...SIDE_MENU[LANGUAGE.es.short]
		},
		globalSearchSections: {
			...GLOBAL_SEARCH_SECTIONS[LANGUAGE.es.short]
		},
		projectPage: {
			...PROJECT_TRANSLATIONS[LANGUAGE.es.short]
		},
		searchPage: {
			...SEARCH_PAGE_TRANSLATIONS[LANGUAGE.es.short]
		},
		homePage: {
			...HOME_PAGE[LANGUAGE.es.short]
		},
		labels: {
			...LABEL_TRANSLATIONS[LANGUAGE.es.short]
		},
		notifications: {
			...NOTIFICATION_TRANSLATIONS[LANGUAGE.es.short]
		},
		managementPage: {
			...MANAGEMENT_STATUSES[LANGUAGE.es.short],
			...MANAGEMENT_PAGE[LANGUAGE.es.short]
		},
		content: {
			...LOGIN_PAGE[LANGUAGE.es.short],
		},
		buttons: {
			...BUTTONS[LANGUAGE.es.short]
		},
		validatedProjectMessage: "El contenido fue validado por {validator} el {date}.",
		revalidate: 'Revalidar',
		notValidatedProjectMessage: "Este proyecto se traduce automáticamente. Por favor, revise y edite si es necesario.",
		...MY_PROJECTS_PAGE[LANGUAGE.es.short],
		...SAVED_PROJECTS[LANGUAGE.es.short],
		search: {
			...VALIDATE_IN[LANGUAGE.es.short],
		},
		aboutTheClientPPT: {
			...ABOUT_THE_CLIENT_PPT[LANGUAGE.es.short]
		},
		homePPT: {
			...HOME_PPT[LANGUAGE.es.short]
		},
		clientContextPPT: {
			...CLIENT_CONTEXT_PPT[LANGUAGE.es.short]
		},
		endPPT: {
			...END_SLIDE_PPT[LANGUAGE.es.short]
		},
		additionalInformationPPT: {
			...ADDITIONAL_INFORMATION_PPT[LANGUAGE.es.short]
		},
		commonPPT: {
			...COMMON_PPT[LANGUAGE.es.short]
		},
		picturePPT: {
			...PICTURES_PPT[LANGUAGE.es.short]
		},
		clientResultPPT: {
			...CLIENT_RESULT_PPT[LANGUAGE.es.short]
		},
		commonDOCX: {
			...COMMON_DOCX[LANGUAGE.es.short]
		},
		homeDOCX: {
			...HOME_DOCX[LANGUAGE.es.short]
		},
		aboutTheClientDOCX: {
			...ABOUT_THE_CLIENT_DOCX[LANGUAGE.es.short]
		},
		clientContextDOCX: {
			...CLIENT_CONTEXT_DOCX[LANGUAGE.es.short]
		},
		akkoidsSolutionDOCX: {
			...AKKODIS_SOLUTION_DOCX[LANGUAGE.es.short]
		},
		clientResultDOCX: {
			...CLIENT_RESULT_DOCX[LANGUAGE.es.short]
		},
		additionalInformationDOCX: {
			...ADDITIONAL_INFORMATION_DOCX[LANGUAGE.es.short]
		},
		crudSideMenu: {
			...CRUD_SIDE_MENU[LANGUAGE.es.short]
		},
		common: {
			...COMMON[LANGUAGE.es.short]
		},
		managementLabels: {
			...MANAGEMENT_LABELS[LANGUAGE.es.short]
		},
		controlPanel: {
			...CONTROL_PANEL_TRANSLATIONS[LANGUAGE.es.short]
		},
		landingPage: {
			...LANDING_PAGE[LANGUAGE.es.short]
		},
		errorPage: {
			...ERROR_PAGE[LANGUAGE.es.short]
		},
		gopHomePage: {
			...GOP_HOME_PAGE[LANGUAGE.es.short]
		},
		gopItemPage: {
			...GOP_ITEM_PAGE[LANGUAGE.es.short]
		},
		gopOffers: {
			...GOP_OFFERS[LANGUAGE.es.short]
		},
		commonPdf: {
			...COMMON_PDF[LANGUAGE.es.short]
		},
		submissionForm: {
			...DRC_SUBMISSION_FORM_TRANSLATIONS[LANGUAGE.es.short]
		},
		subscriptions: {
			...DRC_SUBSCRIPTIONS[LANGUAGE.es.short]
		},
		gopHomePageTranslations: {
			...GOP_HOME_PAGE_TRANSLATIONS[LANGUAGE.es.short]
		},
		gopSearchTranslations: {
			...GOP_SEARCH_TRANSLATIONS[LANGUAGE.es.short]
		},
		gopFooter: {
			...GOP_FOOTER[LANGUAGE.es.short]
		},
		gopComponents: {
			...GOP_COMPONENTS[LANGUAGE.es.short]
		},
		gopViewPage: {
			...GOP_VIEW_PAGE[LANGUAGE.es.short]
		}
	}
};

const i18n = new VueI18n({
	locale: LANGUAGE.en.short,
	fallbackLocale: LANGUAGE.en.short,
	messages: translations
});

export default i18n;
